module.exports = new __parcel__URL__("revolver.9b863470.jpg").toString();